import { SmartTargetStatus } from "../../../types/types";
import StatusChip from "../../UI/StatusChip/StatusChip";

interface SmartTargetStatusChipProps {
	type: SmartTargetStatus;
}

export default function SmartTargetStatusChip({ type }: SmartTargetStatusChipProps) {
	return <StatusChip status={type} />;
}
